<template> 

  <div class="container pt-4 mb-5">
     
    <div>
      
      <b-row align-v="center">

        <b-col lg="12">
 
          <div class="mt-4">

            <div class="mt-3">

              <label>Opisz w kilku słowach Twój problem:</label>

              <b-input-group>

                <b-form-input v-model="temat" size="lg" ref="temat" placeholder="np. brak klientów w firmie"></b-form-input>
                
              </b-input-group>
 
            </div>

            <div class="mt-3">

              <label>Wybierz doradcę:</label>

              <b-input-group>

                <b-form-select v-model="doradca" size="lg" ref="doradca" :options="doradcy"></b-form-select>

              </b-input-group>

            </div>

          </div>

        </b-col>

      </b-row>
  
      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">
        
        </b-col>

        <b-col lg="6">

        <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
          Generuj
        </b-button> 

        </b-col>

      </b-row>



      <div class="mt-2" >
  
        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje tytuły <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Wygenerowane tytuły</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" v-if="result" style="font-size: 1em;">
            
            <div class="mb-3 mt-3 p-3" style="border: 1px dashed #f3f3f3; font-size: 1em; line-height: 1.7em;">

              <div v-if="result" v-html="result" class="pb-3 mb-3" style="border-bottom: 1px solid #ddd;"></div>

            </div>

            <div class="text-primary pointer small mt-1 float-right" @click="copyResults">

              <span class="material-symbols-sharp align-middle">content_copy</span>
              Kopiuj do schowka

            </div>

          </blockquote>

        </b-card>
   
        <textarea ref="selectedText" style="display: none;" v-model="selectedText" v-on:focus="$event.target.select()"></textarea>   
        <textarea ref="finishContent" style="display: none;" v-model="finishContent" v-on:focus="$event.target.select()"></textarea>

      </div>
 
    </div>

  </div>

</template>

<script>

  import { languages } from './../../../resources/languages.js';

  export default {
    name: 'AppArticleSEOIdeas',
    components: {
    },
    data() {
      return {
        isFinish: false,
        result: "",
        result2: "",
        selectedText: '',
        query: "",
        temat: "",
        lang: "Polski",
        languages,
        finishContent: '',
        selectedSchema: null,
        doradcy: [
          "Biznes & Strategia > Strateg Biznesowy",
          "Biznes & Strategia > Konsultant Startupowy",
          "Biznes & Strategia > Mentor E-commerce",
          "Biznes & Strategia > Doradca ds. Marketingu Cyfrowego",
          "Biznes & Strategia > Ekspert SEO",
          "Biznes & Strategia > Analityk Rynku",
          "Biznes & Strategia > Ekspert ds. Sprzedaży B2B",
          "Biznes & Strategia > Doradca ds. Skalowania Firmy",
          "Biznes & Strategia > Trener Negocjacji",
          "Biznes & Strategia > Doradca ds. Budowania Marki",
          "Biznes & Strategia > Konsultant PR",
          "Biznes & Strategia > Specjalista ds. Mediów Społecznościowych",
          "Biznes & Strategia > Ekspert ds. Automatyzacji Biznesu",
          "Biznes & Strategia > Analityk Finansowy",
          "Biznes & Strategia > Doradca ds. Inwestycji",
          "Biznes & Strategia > Konsultant ds. Zarządzania Kryzysowego",
          "Biznes & Strategia > Trener Przywództwa",
          "Biznes & Strategia > Doradca ds. Zarządzania Czasem",
          "Biznes & Strategia > Ekspert ds. Obsługi Klienta",
          "Biznes & Strategia > Konsultant ds. Rozwoju Produktów",
          "Biznes & Strategia > Doradca ds. Crowdfundingu",
          "Biznes & Strategia > Ekspert ds. Marketplace (Amazon, Allegro)",
          "Biznes & Strategia > Doradca ds. Pricingu",
          "Biznes & Strategia > Konsultant ds. Strategii Subskrypcyjnych",
          "Biznes & Strategia > Mentor ds. Skalowania SaaS",

          "Technologia & IT > Architekt Systemów IT",
          "Technologia & IT > Programista PHP/JavaScript",
          "Technologia & IT > Ekspert WordPress",
          "Technologia & IT > DevOps Inżynier",
          "Technologia & IT > Ekspert Cyberbezpieczeństwa",
          "Technologia & IT > Doradca AI/ML",
          "Technologia & IT > Analityk Big Data",
          "Technologia & IT > Specjalista Cloud (AWS/Azure/GCP)",
          "Technologia & IT > Ekspert Blockchain/Web3",
          "Technologia & IT > Tester Oprogramowania",
          "Technologia & IT > Specjalista UI/UX",
          "Technologia & IT > Doradca ds. Automatyzacji (n8n, Zapier)",
          "Technologia & IT > Mentor Data Science",
          "Technologia & IT > Ekspert IoT",
          "Technologia & IT > Doradca ds. API i Integracji",
          "Technologia & IT > Specjalista RPA",
          "Technologia & IT > Doradca IT dla Małych Firm",
          "Technologia & IT > Inżynier Sieciowy",
          "Technologia & IT > Ekspert ds. ERP/CRM",
          "Technologia & IT > Doradca ds. Bezpieczeństwa WordPress",
          "Technologia & IT > Doradca ds. Chatbotów",
          "Technologia & IT > Ekspert ds. Low-Code/No-Code",
          "Technologia & IT > Mentor w GameDev",
          "Technologia & IT > Ekspert ds. Rozszerzonej Rzeczywistości (AR/VR)",
          "Technologia & IT > Doradca ds. Smart Home",

          "Finanse & Biznes > Doradca Kredytowy",
          "Finanse & Biznes > Doradca ds. Nieruchomości",
          "Finanse & Biznes > Specjalista ds. Leasingu",
          "Finanse & Biznes > Doradca Finansów Osobistych",
          "Finanse & Biznes > Trener Oszczędzania",
          "Finanse & Biznes > Doradca ds. Cashflow w Firmie",
          "Finanse & Biznes > Mentor Budżetowania",
          "Finanse & Biznes > Ekspert ds. Startupowych Pitch Decków",
          "Finanse & Biznes > Doradca ds. Fintechów",
          "Finanse & Biznes > Analityk Crowdfundingowych Kampanii",
          "Finanse & Biznes > Doradca ds. Wycen Firm",
          "Finanse & Biznes > Konsultant ds. KPI i Metryk",
          "Finanse & Biznes > Doradca ds. Skalowania Finansowego",
          "Finanse & Biznes > Ekspert ds. Venture Capital",
          "Finanse & Biznes > Konsultant ds. Monetyzacji Aplikacji",
          "Finanse & Biznes > Doradca ds. Abonamentów i Mikropłatności",
          "Finanse & Biznes > Ekspert ds. Automatyzacji Finansów",
          "Finanse & Biznes > Doradca ds. Kontrolingu",
          "Finanse & Biznes > Doradca ds. Modelek Excelowych",

          "Styl życia & Kreatywność > Mentor Kariery",
          "Styl życia & Kreatywność > Coach Życiowy",
          "Styl życia & Kreatywność > Trener Motywacyjny",
          "Styl życia & Kreatywność > Doradca Podróżniczy",
          "Styl życia & Kreatywność > Ekspert ds. Planowania Dnia",
          "Styl życia & Kreatywność > Doradca Minimalizmu",
          "Styl życia & Kreatywność > Doradca ds. Stylu Ubrania",
          "Styl życia & Kreatywność > Konsultant Home Office",
          "Styl życia & Kreatywność > Trener Językowy",
          "Styl życia & Kreatywność > Mentor Edukacyjny",
          "Styl życia & Kreatywność > Doradca ds. Nawyków Produktywności",
          "Styl życia & Kreatywność > Mentor Public Speaking",
          "Styl życia & Kreatywność > Doradca ds. Work-Life Balance",
          "Styl życia & Kreatywność > Doradca Copywritingu",
          "Styl życia & Kreatywność > Trener Pisania Książek",
          "Styl życia & Kreatywność > Mentor YouTube/TikTok",
          "Styl życia & Kreatywność > Doradca ds. Podcastingu",
          "Styl życia & Kreatywność > Ekspert ds. Grafiki AI",
          "Styl życia & Kreatywność > Doradca ds. Fotografii",
          "Styl życia & Kreatywność > Mentor Filmowy",
          "Styl życia & Kreatywność > Doradca ds. Muzyki",
          "Styl życia & Kreatywność > Trener Rysunku i Ilustracji",
          "Styl życia & Kreatywność > Doradca ds. Projektowania 3D",
          "Styl życia & Kreatywność > Doradca Radioamatorski (HAM)",
          "Styl życia & Kreatywność > Doradca DIY/Majsterkowania",
          "Styl życia & Kreatywność > Kreatywny Doradca Pomysłów"
        ]
      }
    },
    methods: {

      generateFinish: function() {

        if(!this.temat) return false;

        this.$refs.generatePost.disabled = true

        this.isFinish = true

        this.finishContent = ""
        this.result = ""

 
        var query = "Wciel się w  " + this.doradca + "  i wykonaj to zadanie (nie formatuj wyniku w markdown, daj sam tekst!): " + this.temat; 


        var doneText = "";

        this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", { 'text': query, 'v': 'o1' }, { withCredentials: true, timeout: 3000000 }).then((response) => {
  
          let data = response.data
 
          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          doneText = data.result;

          this.finishContent = doneText;

          this.result = doneText.replace(/(?:\r\n|\r|\n)/g, '<br/><br/>');


          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowana treść"

        }).catch(function() {

          this.$refs.generatePost.disabled = false

         })
 
        
 
      },
 
      copyResults: function() {
 
        this.$refs.finishContent.style.display = "block";
        
        this.$refs.finishContent.focus();

        document.execCommand('copy');
         
        this.$refs.finishContent.style.display = "none"

        window.scrollTo(0, 0)

        this.$bvToast.toast('Treść została skopiowana do schowka', {
          title: 'Skopiowano',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })

      } 

    },
    computed: {
  
    },
    created() {


 
    },
    mounted() {

      if (localStorage.generators_language) {

        this.lang = localStorage.generators_language;

      } else {

        localStorage.generators_language = "Polski"
        this.lang = "Polski"
      }

    },
    watch: {

      lang(data) {

        localStorage.generators_language = data;

      },

    }


  }
</script>

<style>

  .pointer { cursor: pointer; }
  .bold { font-weight: 600 !important; }
  code { color: #4e82f7 !important; }
</style>